var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("wrapper", { staticClass: "header-menu-row" }, [
    _c("div", { staticClass: "header-row-top" }, [
      _c(
        "a",
        {
          staticClass: "header-mail",
          attrs: { href: "mailto:info@russoutdoor.ru" }
        },
        [_vm._v("info@russoutdoor.ru")]
      ),
      _c(
        "a",
        { staticClass: "header-tel", attrs: { href: "tel:+74956265200" } },
        [_vm._v("+7 (495) 626-52-00")]
      )
    ]),
    _c(
      "div",
      { staticClass: "header-row" },
      [
        _c(
          "div",
          { staticClass: "logo-item" },
          [
            _c("link-to", { staticClass: "logo", attrs: { to: "/" } }, [
              _c("img", { attrs: { src: "/logo.png", alt: "Russ Outdoor" } })
            ])
          ],
          1
        ),
        _c("site-menu", {
          staticClass: "menu-desktop",
          on: {
            currentMenu: function($event) {
              _vm.currentMenu($event)
            }
          }
        }),
        _c(
          "div",
          {
            staticClass: "mobile-menu--trigger",
            class: { "menu-open": _vm.isMenuOpen },
            on: {
              click: function($event) {
                _vm.toggleMenu(true)
              }
            }
          },
          [_vm._v("Меню")]
        ),
        _c(
          "div",
          { staticClass: "mobile-menu", class: { open: _vm.isMenuOpen } },
          [_c("site-menu")],
          1
        ),
        _vm.searchForm && false ? _c("search-form") : _vm._e(),
        _vm.isMenuOpen
          ? _c("div", {
              staticClass: "mobile-menu--overlay",
              on: {
                click: function($event) {
                  _vm.toggleMenu(false)
                }
              }
            })
          : _vm._e()
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-e348a07a", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-e348a07a","hasScoped":false,"transformToRequire":{"video":"src","source":"src","object":"src","embed":"src"},"preserveWhitespace":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./components/header/HeaderMenu.vue
// module id = SZ6z
// module chunks = 41